export const TEMPLATE_WEBMCP_LOG_PREFIX = '[Template WebMCP]';

/** Must match the CLI version in docs (`npx @mcp-b/webmcp-local-relay@…`). */
export const MCP_B_PACKAGE_VERSION = '5.1.0';

export const MCP_B_RELAY_EMBED_SCRIPT_ID = 'webmcp-local-relay-embed';

/** Must match `--workspace` on the local relay MCP server entry. */
export const MCP_B_RELAY_WORKSPACE = 'template-builder';

const CREATIVE_HUB_ORIGIN = String(process.env.VITE_BASE_URL ?? '').replace(/\/$/, '');

// Mirrored from @mcp-b/webmcp-local-relay dist/browser on postinstall
// (`pnpm webmcp:sync-embed`). Origin comes from VITE_BASE_URL so a federated
// shell still loads the script from Creative Hub, not jsDelivr. The filename and
// directory are fixed: embed.js fetches `widget.html` next to its own src.
export const MCP_B_RELAY_EMBED_SRC = `${CREATIVE_HUB_ORIGIN}/webmcp/embed.js`;

/** Same-origin embed on local dev even when the bundle was built with a remote VITE_BASE_URL. */
export function resolveMcpRelayEmbedSrc(): string {
  if (typeof window === 'undefined') {
    return MCP_B_RELAY_EMBED_SRC;
  }
  const { origin, protocol, hostname } = window.location;
  if (protocol === 'http:' && (hostname === 'localhost' || hostname === '127.0.0.1')) {
    return `${origin}/webmcp/embed.js`;
  }
  return MCP_B_RELAY_EMBED_SRC || `${origin}/webmcp/embed.js`;
}
